module.exports = __webpack_public_path__ + "img/403_forbidden.d90bd8c5.svg";